import React from "react";

function RolesAndPermission () {
  return (
    <div> this is list of RolesAndPermission</div>
  )
}

export default RolesAndPermission